import get from "lodash/get"
import axios from "axios"
import { generateUniqueID } from "utils-lib/requests"
import { urls } from "utils-lib/builds"
import {
  SET_CART_DETAILS_PENDING,
  SET_CART_DETAILS_FULFILLED,
  SET_CART_DETAILS_FAILED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: SET_CART_DETAILS_PENDING,
})

export const failedAC = (data) => ({
  type: SET_CART_DETAILS_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: SET_CART_DETAILS_FULFILLED,
  payload: data,
})

const getMiawChatInfoFromStorage = () => {
  try {
    const stored = sessionStorage.getItem(`miawChatInfo`)
    if (stored) {
      const parsed = JSON.parse(stored)
      return {
        MIAWSessionId: parsed?.MIAWSessionId || ``,
        MIAWChatToken: parsed?.MIAWChatToken || ``,
      }
    }
  } catch (e) {
    // ignore parse errors
  }
  return { MIAWSessionId: ``, MIAWChatToken: `` }
}

export const setCartDetails =
  (postData, LDFFReleasePersistentLiveChat) => (dispatch, getState) => {
    const api = `SET_CART`
    const url = urls.url[api]
    const state = getState()
    const cartId = get(state, `ecommerceCart.id`, ``)

    !postData?.isSaveCartEmail && dispatch(pendingAC())
    let payload = postData
    if (LDFFReleasePersistentLiveChat) {
      const { MIAWSessionId = ``, MIAWChatToken = `` } =
        getMiawChatInfoFromStorage()
      const isSalesChat = MIAWSessionId !== `` && MIAWChatToken !== ``
      console.warn(`[MIAW] setCartDetails reading localStorage`, {
        MIAWSessionId,
        MIAWChatToken,
        isSalesChat,
      })
      payload = {
        ...postData,
        ...(isSalesChat && { chatinfo: { MIAWSessionId, MIAWChatToken } }),
      }
    }

    const postType = cartId === `` ? axios.post : axios.put

    return postType(url, LDFFReleasePersistentLiveChat ? payload : postData, {
      headers: {
        "Content-Type": `application/json`,
        ClientId: urls.cloudCraze.headers.ClientId,
        "Request-Tracking-Id": generateUniqueID(),
      },
    })
      .then((response) => {
        if (!postData?.isSaveCartEmail) {
          dispatch(fulfilledAC(response.data))
        }
        return response.data
      })
      .catch((error) => {
        dispatch(failedAC(error?.response?.status))
        return error
      })
  }
